import QBDItemMappableFieldEnum from "./QBDItemMappableFieldEnum";
import QBDItemSourceFieldEnum from "./QBDItemSourceFieldEnum";

/**
 * Per-field QBD item sync configuration for one Orderwerks Catalog Item field (OR-1490).
 */
export default interface IQBDItemFieldMapping {
    /** Which QBD item value populates this field (text fields only). null / undefined = the field's default source. */
    source?: QBDItemSourceFieldEnum | null;
    /** When true, QBD syncs never overwrite this field on an existing Catalog Item. New items are still populated. */
    skipUpdate?: boolean;
}

/** Keyed by Catalog_Item column; stored as JSON on Supplier_Integration.qbd_item_field_mappings. */
export type IQBDItemFieldMappings = Partial<Record<QBDItemMappableFieldEnum, IQBDItemFieldMapping>>;

/** The fields for which a `source` is honored. All mappable fields honor `skipUpdate`. */
export const QBD_ITEM_SOURCE_MAPPABLE_FIELDS: QBDItemMappableFieldEnum[] = [
    QBDItemMappableFieldEnum.name,
    QBDItemMappableFieldEnum.sku,
    QBDItemMappableFieldEnum.description,
    QBDItemMappableFieldEnum.upc,
];
